import React from "react";

import feature1 from "../assets/images/banner/2.jpg";
import feature2 from "../assets/images/banner/3.jpg";
import feature3 from "../assets/images/banner/1.jpg";
import "../assets/css/Features.css";


const Features = () => {
  return (
    <section className="ts-features no-padding">
      <div className="container-fluid">
        <p className="pt-3 text-center technology">TECHNOLOGY FOCUSED</p>

        <p className="text-center">
          We back founders and talented teams at all stages of growth, from
          startups to established market leaders
        </p>

        <div className="row">
          {/* Feature 1 */}
          <div
            className="col-lg-4 feature-box1"
            style={{
              backgroundImage: `url(${feature1})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="text-center ts-feature">
              <div className="ts-feature-info">
                <i className="icon icon-consut2"></i>

                <h3 className="ts-feature-title">
                  Software Engineering
                </h3>

                <p>
                 Delivering robust, scalable, and efficient software solutions tailored to your business needs. Our software engineering team combines innovation with precision to build high-performance systems that drive results—on time, every time.
                </p>
              </div>
            </div>
          </div>

          {/* Feature 2 */}
          <div
            className="col-lg-4 feature-box2"
            style={{
              backgroundImage: `url(${feature2})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="text-center ts-feature">
              <div className="ts-feature-info">
                <i className="icon icon-chart2"></i>

                <h3 className="ts-feature-title">IT Consulting</h3>

                <p>
                 Empowering businesses with expert IT consulting services. We analyze, strategize, and implement technology solutions that drive efficiency, scalability, and growth. From digital transformation to infrastructure optimization, we’re your trusted technology partner.
                </p>
              </div>
            </div>
          </div>

          {/* Feature 3 */}
          <div
            className="col-lg-4 feature-box3"
            style={{
              backgroundImage: `url(${feature3})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="text-center ts-feature">
              <div className="ts-feature-info">
                <i className="icon icon-clock3"></i>

                <h3 className="ts-feature-title">Nurturing</h3>

                <p>
               Build a secure financial future with Innothurst. Our seasoned experts deliver personalized investment strategies designed to maximize growth and minimize risk. From portfolio management to wealth planning, we’re committed to helping you reach your financial goals with confidence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;